import { api } from "api/api";
import { AxiosError } from "axios";
import VeiculoViagemDashboard from "model/gestao/frotas/dashboard/VeiculoViagemDahboard";
import VeiculoViagemDashboardFilters from "model/gestao/frotas/dashboard/VeiculoViagemDashboardFilters";

class VeiculoViagemDashboardService {

    getDashboard(filters?: VeiculoViagemDashboardFilters) {
        return new Promise<VeiculoViagemDashboard>((resolve, reject): void => {
            let url = `/veiculoViagem/dashboard?filters=`;
            url += encodeURIComponent(JSON.stringify(filters))

            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default VeiculoViagemDashboardService;